import { useState } from "react";
import { BsFillHeartFill, BsDownload, BsClipboard, BsCheck2Square} from "react-icons/bs";
import Myresume from "../resources/Peter_Johnson.pdf";

const Footer = () => {

  const [isCopied, setIsCopied] = useState(false);

  return (  
    <div className="bg-fC text-center dark:bg-dPrimary dark:text-primaryC">
      <div className="text-white pt-8 pb-9 flex items-center justify-center">
        <p className="font-extralight px-5">Drop me a mail @ <span className="underline font-light">peterj1298@gmail.com</span></p>
        <div
        className="cursor-pointer"
          onClick = { () => {
            navigator.clipboard.writeText("peterj1298@gmail.com");
            setIsCopied(true);
            setTimeout(() => {
              setIsCopied(false);
            }, 5000);
          }}
        >
          {isCopied === true ? (<BsCheck2Square />) : (<BsClipboard />)}
        </div>
      </div>
      <div className="text-primaryC flex justify-center items-center ">
        <h1>Made with</h1>
        <div className="px-1">
          <BsFillHeartFill />
        </div>
        <h1>and React</h1>
      </div>
      <div className="text-primaryC mb-5 mt-10 inline-block content-center items-center cursor-pointer border p-3 px-5 rounded-md hover:bg-white hover:text-pcC animate-bounce">
        <div className="flex items-center">
          <BsDownload />
          <a href={Myresume} download className="ml-3">
            Resume
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
